import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        errorTypeEnum: {
            workflowUidShouldBeUniq: 'Erreur de validation',
            workflowLabelShouldBeUniq: 'Ce nom de workflow est déjà utilisé',
            requestCanBeLinkedToOnlyOneWorkflow: 'Un workflow utilise déjà cette demande',
            stepOrderError: 'L\'ordre des tâches est invalide',
            impossibleToRemoveThisStepBecauseNextDependsOnIt: 'La tâche suivante dépend de celle-ci',
            stepDoesNotExist: 'La tâche n\'existe pas',
            workflowDoesNotExist: 'Le workflow n\'existe pas',
            stepCoherencyError: {
                shouldHaveNoEventAfterThisStep: 'Aucune tâche ne peut apparaître après {stepInError}',
                shouldNotBeAfterTheseEvents: '{stepInError} ne peut apparaître après {stepsBefore}'
            },
            companyDoesNotHaveRequieredBillingTypeLevel: 'Seul les entreprises {expectedLevels} peuvent créer un workflow',
            workflowNumberLimitExceeded: 'Votre type de compte vous permet de créer {limit} workflows maximum. Merci de contacter votre chargé de compte si besoin'
        },
        billingTypeEnum: {
            standardAccount: 'compte standard',
            premiumAccount: 'compte prémium',
            sponsoredAccount: 'compte sponsorisé'
        },
        newWorkflow: 'nouveau workflow',
        workflowLabel: 'saisisez le nom du workflow',
        updateWorkflowLabel: 'modification',
        newStep: 'nouvelle tâche',
        fillStep: 'saisissez une tâche',
        saveStep: 'enregistrer la tâche',
        updateStep: 'modifier la tâche',
        identifiedRequests: 'type d\'incident',
        openTicket: 'ouverture du ticket',
        expectedEvent: 'Nom de la tâche',
        expectedEventEnum: {
            documentAttached: 'Document attaché',
            callEmittedTo: 'Appel sortant',
            callReceived: 'Appel reçu',
            assigneeIdentified: 'Intervenant identifié',
            interventionDeadlineDefined: 'Date butoir d\'intervention',
            formalNoticeForProviderReported: 'Fournisseur mis en demeure',
            sendingServiceOrderReported: 'OE envoyé',
            callAnsweredByProvider: 'Réponse à l\'appel',
            callNotAnsweredByProvider: 'Pas de réponse à l\'appel',
            interventionRequested: 'Intervention demandée',
            interventionAccepted: 'Prise en charge',
            interventionRefused: 'Mission refusée',
            interventionScheduled: 'Intervention prévue',
            arrivedOnSite: 'Arrivée du fournisseur sur site',
            goneFromSite: 'Départ du fournisseur du site',
            interventionStarted: 'Intervention débuté par le fournisseur',
            interventionFinished: 'Intervention terminée par le fournisseur',
            missionFinished: 'Mission terminée',
            ticketCancelled: 'Ticket annulé',
            ticketClosed: 'Ticket clos',
            ticketArchived: 'Ticket archivé',
            permanentlyFixed: 'Réparation définitive',
            partiallyFixed: 'Réparation provisoire',
            ticketClosedImpossibleRepair: 'Réparation impossible',
            postponedFix: 'Réparation ajournée',
            closedBeyondCallCenterScope: 'Hors périmètre',
            closedAfterSeveralUnsuccessfulRecalls: 'Clôture suite à plusieurs relances infructueuses'
        },
        expectedCommandEnum: {
            notifyCallEmitted: 'Emettre un appel',
            notifyCallReceived: 'recevoir un appel',
            identifyAssignee: 'Sélectionner le fournisseur',
            changeRecourse: 'Changer de recours',
            defineInterventionDeadline: 'Définir une date butoir d\'intervention',
            reportFormalNoticeForProvider: 'Définir une date butoir de mise en demeure',
            reportSendingServiceOrder: 'Consigner le Numéro d\'ordre de service',
            notifyCallAnsweredByProvider: 'Répondre à l\'appel',
            notifyCallNotAnsweredByProvider: 'Ne pas répondre à l\'appel',
            requestIntervention: 'Demander l\'intervention',
            acceptIntervention: 'Prendre en charge l\'intervention',
            refuseIntervention: 'Refuser l\'intervention',
            scheduleIntervention: 'Programmer l\'intervention',
            arriveOnSite: 'Déclarer l\'arrivée du fournisseur sur le site',
            goFromSite: 'Déclarer le départ du fournisseur sur du site',
            startIntervention: 'Déclarer le début d\'intervention',
            finishIntervention: 'Déclarer la fin d\'intervention',
            finishMission: 'Finir la mission',
            cancelTicket: 'Annuler le ticket',
            closeTicket: 'Clôturer le ticket',
            archiveTicket: 'Archiver le ticket',
            fixPermanently: 'Déclarer une réparation définitive',
            fixPartially: 'Déclarer une réparation partielle',
            closeTicketImpossibleRepair: 'Déclarer une réparation impossible',
            postponeFix: 'Déclarer une réparation ajournée',
            closeBeyondCallCenterScope: 'Déclarer le ticket en dehors du scope du centre d\'appel',
            closeAfterSeveralUnsuccessfulRecalls: 'Clôturer le ticket suite à relances infructueuses'
        },
        actors: 'Responsables',
        actorEnum: {
            callCenterOperator: 'Opérateur',
            executive: 'Cadre',
            patrimonyManager: 'Gestionnaire'
        },
        order: 'Position',
        duration: 'Durée',
        stepTimeLimitType: 'Contrainte de temps',
        stepTimeLimitTypeEnum: {
            durationAfterPreviousStep: 'Après la dernière étape'
        },
        removeWorkflowText: [
            'Vous êtes sur le point de supprimer le workflow {label}.',
            'Cette action est irréversible.'
        ],
        nextStep: 'prochaine action attendue',
        overdue: 'dépassé',
        todolist: 'liste des actions à réaliser',
        todos: 'actions',
        youHaveNoTodo: 'Vous n\'avez pas de tâche à réaliser. Pour définir vos processus, merci de contacter votre chargé de compte',
        youHaveNoTodoClickText: [
            'Vous n\'avez pas de tâche à réaliser. Pour définir vos processus, merci de ',
            'cliquer ici',
            ' ou de contacter votre chargé de compte'
        ],
        youAreOperator: 'Vous êtes intervenu sur ce ticket',
        newTicket: 'nouveau ticket',
        searchAgency: 'filtrer par portefeuille',
        searchCompany: 'filtrer par entreprise',
        searchExpectedCommand: 'filtrer par action',
        searchActor: 'filtrer par responsable',
        searchOperator: 'filtrer par opérateur',
        expectedDateStatus: 'délais des actions',
        expectedDateStatusEnum: {
            todo: 'courant',
            todoWithin12Hours: 'prioritaire',
            timeout: 'urgent'
        } 
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/workflow/i18n.js